import { cx } from '../utils/cx'
import type { CardProps } from './types'
import './Card.css'

/** Tarjeta base (DESIGN.md §4): blanca, radio 16, borde 1 px, sin sombra en reposo. */
export function Card({
  children,
  highlighted,
  image,
  imageAlt = '',
  flush,
  hoverable,
  onClick,
  as = 'div',
  className,
  style,
  ...rest
}: CardProps) {
  const classes = cx(
    'hp-card',
    highlighted && 'hp-card--highlighted',
    hoverable && 'hp-card--hoverable',
    onClick && 'hp-card--clickable',
    className,
  )
  const media = image ? (
    <div className="hp-card__media">
      {typeof image === 'string' ? <img src={image} alt={imageAlt} className="hp-card__img" /> : image}
    </div>
  ) : null
  const body = <div className={cx('hp-card__body', flush && 'hp-card__body--flush')}>{children}</div>

  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={classes} style={style} aria-label={rest['aria-label']}>
        {media}
        {body}
      </button>
    )
  }
  const Tag = as
  return (
    <Tag className={classes} style={style}>
      {media}
      {body}
    </Tag>
  )
}
